import React, { SyntheticEvent } from "react";
import { Button, Tooltip } from "antd";

interface IProps {
  onClick: (e: SyntheticEvent) => void;
  disabled?: boolean;
  style?: { [key: string]: string };
  tooltipTitle?: string;
}

const DownloadFile = ({ disabled, style, onClick, tooltipTitle }: IProps) => {
  const icon = (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginBottom: disabled ? "-4px" : 0 }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14.625H13.5V11.25H15.75V14.625V16.875H0V14.625ZM0 11.25H2.25V14.625H0V11.25ZM5.625 0H10.125V7.875H12.375L7.875 13.5L3.375 7.875H5.625V0Z"
        fill={disabled ? "#CCDDEE" : "#00BBFF"}
        // fill="#00BBFF"
      />
    </svg>
  );
  return (
    <Tooltip title={tooltipTitle || ""}>
      <Button
        style={{
          ...style,
          background: "transparent",
          border: "none",
          boxShadow: "none",
        }}
        icon={icon}
        disabled={disabled}
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default DownloadFile;
